/**************************************************
 * Nombre:       Tablero_Crm
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Columna_Basica from "./Columnas/Columna_Basica";

const Tablero_Crm = ({refe, config, coleccion, cargar, carga, wheresAdicionaless}) => {


    return (
        <Grid
            ref={refe}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
            sx={{
                flexWrap: 'nowrap',
                overflowX: 'auto', // 'auto' es visualmente más limpio que 'scroll' porque solo aparece la barra si es necesario
                width: '100%',
                scrollbarWidth: 'none', // Oculta la barra de scroll nativa en Firefox
                '&::-webkit-scrollbar': {display: 'none'}, // Oculta la barra en Chrome/Safari
                scrollBehavior: 'smooth' // Asegura transiciones suaves si falla el scrollBy
            }}
        >

            {config && config.columnas && config.columnas.map((item, index) => (
                <Grid key={'ww8' + index} sx={{flexShrink: 0, minWidth: '250px'}}>
                    <Columna_Basica item={item} index={index} coleccion={coleccion} cargar={cargar} carga={carga}
                                    wheresAdicionaless={wheresAdicionaless}/>
                </Grid>
            ))}


        </Grid>
    )

}
export default Tablero_Crm    